module.exports = __webpack_public_path__ + "img/17.1036be65.png";